import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Stack, Container, Typography, Link } from '@material-ui/core';

// routes
import { PATH_AUTH } from '../../routes/paths';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import { LoginForm } from '../../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center'
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(4, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title="Login | AL IKHTHAYAR TRADING LLC">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="column" alignItems="center" spacing={2} sx={{ mb: 3, textAlign: 'center' }}>
            <Logo sx={{ width: 64, height: 64, mb: 1 }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                AL IKHTHAYAR TRADING LLC
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Please enter your credentials to access your account.
              </Typography>
            </Box>
          </Stack>

          <LoginForm />

          {/* <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Don’t have an account?&nbsp;
            <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
              Get started
            </Link>
          </Typography> */}

          <Typography variant="body2" align="center" sx={{ mt: 2, color: 'text.disabled' }}>
            © {new Date().getFullYear()} Al Ikthayar Trading LLC. All rights reserved.
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}